module.exports = __webpack_public_path__ + "static/media/item.538324ac.png";